"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAvailableWaiveFormulaFieldsProposals = exports.createWaiveConfigEvaluator = exports.checkWaiveConfigErrors = void 0;
const lodash_1 = __importDefault(require("lodash"));
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const waiveConfigFormulaAvailableVariablesConfigs = {
    'loanTapeMetadata.reportingDate': {
        label: 'loanTapeMetadata.reportingDate',
        description: 'Loan tape reporting date (loan tape metadata)',
    },
    'receivables.totalReceivableValuation': {
        label: 'receivables.totalReceivableValuation',
        description: 'Total receivable valuation',
    },
    'receivables.totalEligibleExposure': {
        label: 'receivables.totalEligibleExposure',
        description: 'Total Eligible Exposure',
    },
};
const waiveConfigFormulaAvialableVariables = Object.keys(waiveConfigFormulaAvailableVariablesConfigs);
const checkWaiveConfigErrors = ({ waiveConfigs, }) => {
    const availableVariables = new Set(waiveConfigFormulaAvialableVariables);
    const missingVariablesPerField = waiveConfigs.map((waiveConfig) => {
        const formulaErrors = (0, formula_engine_1.getFormulaErrors)(waiveConfig.config.formula, availableVariables);
        return Object.assign({ reason: waiveConfig.reason }, formulaErrors);
    });
    // filter out things that are not really missing.
    const definitelyMissing = missingVariablesPerField.filter(({ missingVariables }) => missingVariables.length > 0);
    return definitelyMissing;
};
exports.checkWaiveConfigErrors = checkWaiveConfigErrors;
const createWaiveConfigEvaluator = (waiveConfigs, f1EngineMode) => {
    // extract formulas from the config.
    // instantiate FormulaEngine with all formula strings
    // we need to do this upfront to ensure that formula's AST are cached.
    const formulaStrings = waiveConfigs.map((config) => {
        (0, common_1.finleyAssert)(config.config.engineVersion ===
            finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, `${config.config.engineVersion} is not yet supported`);
        return config.config.formula;
    });
    const formulaEngine = (0, formula_engine_1.createFormulaEngine)(finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, formulaStrings, f1EngineMode);
    const setVariables = (inputs) => {
        formulaEngine.setVariables(inputs, { flatten: true });
    };
    const evaluate = (inputs) => {
        setVariables(inputs);
        // find 1st waiver that evaluates to true.
        const waivedConfig = waiveConfigs.find((config) => formulaEngine.evaluateBoolean(config.config.formula));
        // if a waiver evaluated to true, find the reason, otherwise null.
        return waivedConfig ? waivedConfig.reason : null;
    };
    return {
        evaluate,
    };
};
exports.createWaiveConfigEvaluator = createWaiveConfigEvaluator;
/**
 * Generates list of helpful fields available to a waive config formula CompletionItems for Monaco Editor
 */
const createAvailableWaiveFormulaFieldsProposals = () => lodash_1.default.map(waiveConfigFormulaAvailableVariablesConfigs, ({ label, description }) => {
    return {
        label,
        documentation: description,
        insertText: label,
    };
});
exports.createAvailableWaiveFormulaFieldsProposals = createAvailableWaiveFormulaFieldsProposals;
//# sourceMappingURL=waiverEvaluator.js.map